import axios from '../axiosConfig';

var deployPath = process.env.REACT_APP_SERVER_URL || "";

export default {  
  quoterPurchase: (request) => {
    return axios.post(`${deployPath}/api/payments/quoterPurchase`, request)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },
  quoterPurchaseNoCard: (request) => {
    return axios.post(`${deployPath}/api/payments/quoterPurchaseNoCard`, request)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },
}